import React, { useState, useEffect } from "react";

const PreviewText = ({
  value,
  TickerStart,
  TickerPosition,
  zInd,
  CanvasDisplay,
  index,
  OnePx,
  EditorZoom,
}) => {
  var TypeWriterPlaying = false,
    wordByWordTimeDiff = 0; //, WordByWordFadeTimeoutsArr = [], WordByWordFadeIntervalsArr = [];

  var startIndex = 0;

  const [WordByWordFadeTimeoutsArr, setWordByWordFadeTimeoutsArr] = useState(
    []
  );

  const [WordByWordFadeIntervalsArr, setWordByWordFadeIntervalsArr] = useState(
    []
  );

  const [IsPaused, setIsPaused] = useState(false);

  const [timeOut, settimeOut] = useState(null);

  const totalTimeToMs = (TotalLength) => {
    let timeSplitted = TotalLength.split(":");
    let hours = parseInt(timeSplitted[0]);
    let mins = parseInt(timeSplitted[1]);
    let sec = parseInt(timeSplitted[2]);
    let ms = parseInt(timeSplitted[3]);
    let hoursToMs = hours * 60 * 60 * 1000;
    let minsToMs = mins * 60 * 1000;
    let secToMs = sec * 1000;
    return hoursToMs + minsToMs + secToMs + ms;
  };

  const calculateTimeByWidth = (width) => {
    let ms = parseFloat((width * OnePx).toFixed(3));
    return msToTime(ms);
  };

  const msToTime = (s) => {
    function pad(n, z) {
      z = z || 2;
      return ("00" + n).slice(-z);
    }
    var ms = s % 1000;
    s = (s - ms) / 1000;
    var secs = s % 60;
    s = (s - secs) / 60;
    var mins = s % 60;
    var hrs = (s - mins) / 60;
    return (
      pad(hrs) +
      ":" +
      pad(mins) +
      ":" +
      pad(secs) +
      ":" +
      pad(Math.round(ms), 3)
    );
  };

  function timers(count, bounceInMs, callback) {
    var timers = [];
    for (var i = 0; i < count; i += bounceInMs) {
      timers.push(timer(callback, i));
    }
    setWordByWordFadeTimeoutsArr(WordByWordFadeTimeoutsArr);
    return timers;
  }
  //Function to compose individual timer

  function timer(callback, delay) {
    return function () {
      WordByWordFadeTimeoutsArr.push(setTimeout(callback, delay));
    };
  }

  function resumeWordByWordFade(obj) {
    let span = document.getElementById(obj.id);
    resumeOpacityWordByWord(span);
  }

  function resumeOpacityWordByWord(span) {
    let opacity = Number(
      window.getComputedStyle(span).getPropertyValue("opacity")
    );
    if (opacity < 1 && opacity > 0) {
      let interval;
      if (span && !span.getAttribute("data-empty")) {
        interval = setInterval(() => {
          if (opacity < 1) {
            opacity = opacity + value.wordByWordFadeInData.opacityIncrement; //0.03;
            span.style.opacity = opacity;
          } else {
            clearInterval(interval);
          }
        }, value.wordByWordFadeInData.perWordFPS); //60

        WordByWordFadeIntervalsArr.push(interval);
        setWordByWordFadeIntervalsArr(WordByWordFadeIntervalsArr);
        wordByWordTimeDiff =
          wordByWordTimeDiff + value.wordByWordFadeInData.perWordMS; //500;
      }
    } else if (opacity == 0) {
      if (span && !span.getAttribute("data-empty")) {
        animateWordOpacity(span);
      }
    }
  }

  function triggerWordByWordFade($el, obj) {
    // setTimeout(() => {
    if ($el) {
      let span = document.createElement("span");
      span.id = obj.id;
      span.style.opacity = 0;
      if (obj.word == "") {
        span.style.opacity = 1;
        span.setAttribute("data-empty", "1");
      }
      span.innerHTML = obj.word + obj.next;
      $el.appendChild(span);
      // const id = window.requestAnimationFrame(step);
      // Ids = id;
      if (span && !span.getAttribute("data-empty")) {
        animateWordOpacity(span);
      }
    }
    // }, wordByWordTimeDiff);
  }

  function animateWordOpacity(span) {
    WordByWordFadeTimeoutsArr.push(
      setTimeout(() => {
        let interval;
        let opacity = Number(
          window.getComputedStyle(span).getPropertyValue("opacity")
        );

        if (span && !span.getAttribute("data-empty")) {
          interval = setInterval(() => {
            if (opacity < 1) {
              opacity = opacity + value.wordByWordFadeInData.opacityIncrement; //0.03
              span.style.opacity = opacity;
            } else {
              clearInterval(interval);
            }
          }, value.wordByWordFadeInData.perWordFPS); //60
          WordByWordFadeIntervalsArr.push(interval);
          setWordByWordFadeIntervalsArr(WordByWordFadeIntervalsArr);
        }
      }, wordByWordTimeDiff)
    );
    setWordByWordFadeTimeoutsArr(WordByWordFadeTimeoutsArr);
    wordByWordTimeDiff =
      wordByWordTimeDiff + value.wordByWordFadeInData.perWordMS; //500;
  }

  //WordByWord Appear Code Starts from here
  function triggerWordByWordAppear($el, obj) {
    if ($el) {
      let span = document.createElement("span");
      span.id = obj.id;
      span.style.opacity = 0;
      if (obj.word == "") {
        span.style.opacity = 1;
        span.setAttribute("data-empty", "1");
      } else {
        span.style.position = "relative";
        span.style.color = "transparent";
        span.style.textShadow = `0 0 10px ${value.textColor}`;
        span.style.fontSize = value.fontSize + 10 + "px";
      }
      span.innerHTML = " " + obj.word + obj.next;
      $el.appendChild(span);
      if (span && !span.getAttribute("data-empty")) {
        animateWordAppear(span);
      }
    }
  }

  function animateWordAppear(span) {
    WordByWordFadeTimeoutsArr.push(
      setTimeout(() => {
        let interval;
        let fontSize = Number(
          window
            .getComputedStyle(span)
            .getPropertyValue("font-size")
            .split("px")[0]
        );
        let textShadow = 10;
        if (span && !span.getAttribute("data-empty")) {
          span.style.opacity = 1;
          interval = setInterval(() => {
            if (fontSize > value.fontSize) {
              fontSize = fontSize - value.wordByWordFadeInData.scaleDecriment;
              textShadow =
                textShadow - value.wordByWordFadeInData.scaleDecriment;
              span.style.fontSize = fontSize + "px";
              span.style.textShadow = `0 0 ${textShadow}px ${value.textColor}`;
            } else {
              span.style.position = "";
              // span.innerHTML = span.innerHTML.split(" ")[1] + " ";
              // span.style.display = '';
              clearInterval(interval);
            }
          }, value.wordByWordFadeInData.perWordFPS); //60
          WordByWordFadeIntervalsArr.push(interval);
          setWordByWordFadeIntervalsArr(WordByWordFadeIntervalsArr);
        }
      }, wordByWordTimeDiff)
    );
    setWordByWordFadeTimeoutsArr(WordByWordFadeTimeoutsArr);
    wordByWordTimeDiff =
      wordByWordTimeDiff + value.wordByWordFadeInData.perWordMS; //value.wordByWordFadeInData.perWordMS; //500;
  }

  function resetWordsByAppear(append = false) {
    if (
      value.startPositionOnTimeline + value.startTransitionWidth >=
      TickerPosition
    ) {
      if (TickerPosition - value.startPositionOnTimeline > 0 || append) {
        var StrCounter = value.WordsArray.length + 1;
        let tickerPositionInEffect =
          TickerPosition - value.startPositionOnTimeline;
        let divider = value.startTransitionWidth / StrCounter;
        let appendIndex = parseInt(tickerPositionInEffect / divider);
        let _opacity = (tickerPositionInEffect / divider) % 1;
        let $el = document.getElementById(value.TextId);
        $el.innerHTML = "";
        for (const j of value.WordsArray) {
          let span = document.createElement("span");
          span.style.opacity = 0;
          span.id = j.id;
          if (j.word == "") {
            span.style.opacity = 1;
            span.setAttribute("data-empty", "1");
          } else {
            span.style.position = "relative";
            span.style.color = "transparent";
            span.style.textShadow = `0 0 10px ${value.textColor}`;
            span.style.fontSize = value.fontSize + 10 + "px";
          }
          span.innerHTML = " " + j.word + j.next;
          $el.appendChild(span);
        }

        for (let j = 0; j < appendIndex - 1; j++) {
          let span = document.getElementById(value.WordsArray[j].id);
          span.style.opacity = 1;
          if (j == appendIndex - 2) {
            //span.style.opacity = _opacity;

            let fontSize =
              Number(span.style.fontSize.split("px")[0]) - _opacity * 10;
            let textShadow = 10 - _opacity * 10;
            span.style.fontSize = fontSize + "px";
            span.style.textShadow = `0 0 ${textShadow}px ${value.textColor}`;
          } else {
            span.style.position = "";
            span.style.fontSize = "";
            span.style.textShadow = "";
            span.style.color = "";
            span.innerHTML = span.innerHTML.split(" ")[1] + " ";
          }
        }
      }
    }
  }

  function resumeWordByWordAppear(obj) {
    let span = document.getElementById(obj.id);
    resumeAppearWordByWord(span);
  }

  function resumeAppearWordByWord(span) {
    let opacity = Number(
      window.getComputedStyle(span).getPropertyValue("opacity")
    );
    let fontSize = parseInt(
      window.getComputedStyle(span).getPropertyValue("font-size").split("px")[0]
    );
    let TextShadow = window
      .getComputedStyle(span)
      .getPropertyValue("text-shadow");
    // if(TextShadow != "none"){
    //   debugger
    //   let TextShadow = window.getComputedStyle(span).getPropertyValue("text-shadow").split(" ")[5].split("px")[0];
    //   console.log("TextShadow: ",TextShadow);
    // }
    let textShadow = 10;
    if (TextShadow != "none") {
      textShadow = Number(
        window
          .getComputedStyle(span)
          .getPropertyValue("text-shadow")
          .split(" ")[5]
          .split("px")[0]
      );
    }
    if (fontSize > value.fontSize && TextShadow != "none" && textShadow != 10) {
      let interval;
      if (span && !span.getAttribute("data-empty")) {
        span.style.opacity = 1;
        interval = setInterval(() => {
          if (fontSize > value.fontSize) {
            fontSize = fontSize - value.wordByWordFadeInData.scaleDecriment;
            textShadow = textShadow - value.wordByWordFadeInData.scaleDecriment;
            span.style.fontSize = fontSize + "px";
            span.style.textShadow = `0 0 ${textShadow}px ${value.textColor}`;
          } else {
            span.style.position = "";
            // span.innerHTML = span.innerHTML.split(" ")[1] + " ";
            clearInterval(interval);
          }
        }, value.wordByWordFadeInData.perWordFPS); //60
        WordByWordFadeIntervalsArr.push(interval); //60

        setWordByWordFadeIntervalsArr(WordByWordFadeIntervalsArr);
        //wordByWordTimeDiff = wordByWordTimeDiff + value.wordByWordFadeInData.perWordMS; //500;
      }
    } else {
      if (span && !span.getAttribute("data-empty")) {
        animateWordAppear(span);
      }
    }
  }

  //Text Bounce in animation

  function triggerLetterBouncing($el, obj, calledForPlay = true) {
    if ($el) {
      let span = document.createElement("span");
      span.id = obj.id;
      if (calledForPlay) {
        span.style.opacity = 0;
      }
      if (obj.character == "") {
        span.style.opacity = 1;
        span.setAttribute("data-empty", "1");
      } else {
        span.style.position = "relative";
        if (calledForPlay) {
          span.style.top = value.fontSize + "px";
        }
      }
      span.innerHTML = obj.character + obj.next;
      $el.appendChild(span);

      // if (span && !span.getAttribute("data-empty")) {
      //   animateLetterBounce(span);
      // }
    }
  }

  function animateLetterBounce() {
    for (let i = 0; i < value.CharactersArray.length; i++) {
      let span = document.getElementById(value.CharactersArray[i].id);
      if (
        span &&
        !span.getAttribute("data-empty") &&
        !span.getAttribute("data-doneBounce")
      ) {
        startIndex = i;
        break;
      }
    }
    let reachedToTop = false;
    let fontSizeDivider = value.fontSize / 4;
    let bounceInMs = value.bounceInMs / 13;
    let totalTime =
      totalTimeToMs(
        calculateTimeByWidth(
          value.startTransitionWidth + value.startPositionOnTimeline
        )
      ) - totalTimeToMs(calculateTimeByWidth(TickerPosition)); //value.bounceInMs * value.cleanCharacterArray.length;
    var set = timers(totalTime, bounceInMs, bounce);

    function bounce() {
      if (!value.player) {
        return;
      }

      let span = document.getElementById(value.CharactersArray[startIndex].id);
      span.style.opacity = 1;
      let top = Number(
        window.getComputedStyle(span).getPropertyValue("top").split("px")[0]
      );

      if (!reachedToTop && top >= 0 - value.fontSize) {
        if (top - fontSizeDivider == 0) {
          top = top - (fontSizeDivider + 1);
        } else {
          top = top - fontSizeDivider;
        }

        if (top <= 0 - value.fontSize) {
          reachedToTop = true;
        }
      } else {
        top = top + fontSizeDivider;
        if (top > 0) {
          top = 0;
        }
      }
      span.style.top = top + "px";

      if (
        top == 0 &&
        reachedToTop &&
        startIndex < value.CharactersArray.length - 1
      ) {
        if (startIndex == value.CharactersArray.length - 1) {
          // for (const i of WordByWordFadeIntervalsArr) {
          //   clearInterval(i);
          // }
          return;
        }
        startIndex++;
        span.setAttribute("data-doneBounce", 1);
        reachedToTop = false;
      }
    }

    for (var i = 0; i < set.length; i++) {
      set[i]();
    }
    // WordByWordFadeIntervalsArr.push(interval)
  }

  // Type Writer animation
  function triggerTypeWriter($el, obj, calledForPlay = true) {
    if ($el) {
      let span = document.createElement("span");
      span.id = obj.id;
      if (calledForPlay) {
        span.style.opacity = 0;
      }
      if (obj.character == "") {
        span.style.opacity = 1;
        span.setAttribute("data-empty", "1");
      }
      span.innerHTML = obj.character + obj.next;
      $el.appendChild(span);
    }
  }

  function animateTypeWriter() {
    for (let i = 0; i < value.CharactersArray.length; i++) {
      let span = document.getElementById(value.CharactersArray[i].id);
      if (
        span &&
        !span.getAttribute("data-empty") &&
        !span.getAttribute("data-doneBounce")
      ) {
        startIndex = i;
        break;
      }
    }
    let bounceInMs = value.bounceInMs;
    if (bounceInMs < 10) {
      bounceInMs = 10;
    }

    let interval = setInterval(() => {
      let span = document.getElementById(value.CharactersArray[startIndex].id);
      span.style.opacity = 1;

      if (startIndex == value.CharactersArray.length - 1) {
        for (const i of WordByWordFadeIntervalsArr) {
          clearInterval(i);
        }
        return;
      }
      startIndex++;
      span.setAttribute("data-doneBounce", 1);
    }, bounceInMs);
    WordByWordFadeIntervalsArr.push(interval);
  }

  //Text Rolling Effect

  function rollSpan(span) {
    let angle = Number(
      window
        .getComputedStyle(span)
        .getPropertyValue("transform")
        .split("(")[1]
        .split("deg")[0]
    );
  }

  function triggerLetterRolling($el, obj, calledForPlay = true) {
    if ($el) {
      let span = document.createElement("span");
      span.id = obj.id;
      if (calledForPlay) {
        span.style.opacity = 1;
      }
      if (obj.character == "") {
        span.style.opacity = 1;
        span.setAttribute("data-empty", "1");
      } else {
        span.style.position = "relative";
        span.style.display = "inline-block";
        span.style.transform = "rotate(360deg)";
        if (calledForPlay) {
          span.style.left = value.fontSize * 3 + "px";
        }
      }
      span.innerHTML = obj.character + obj.next;
      $el.appendChild(span);

      if (span && !span.getAttribute("data-empty")) {
        rollSpan(span);
      }
    }
  }

  useEffect(() => {
    if (value.InClass == "animated WordByWordFade ") {
      if (!value.player) {
        for (const i of WordByWordFadeIntervalsArr) {
          clearInterval(i);
        }
        for (const i of WordByWordFadeTimeoutsArr) {
          clearTimeout(i);
        }
      } else if (TickerPosition > value.startPositionOnTimeline) {
        //&& TickerPosition - value.startPositionOnTimeline > 1
        if (value.text == "") {
          // value.text = value.originalText;
          resetWordsByFade(false);
        }
        for (let i of value.WordsArray) {
          resumeWordByWordFade(i);
        }
      } else if (
        TickerPosition <= value.startPositionOnTimeline &&
        value.text == ""
      ) {
        if (value.draggedBeforeStartPos) {
          resetWordsByFade(true);
          for (let i of value.WordsArray) {
            resumeWordByWordFade(i);
          }
        } else {
          let $el = document.getElementById(value.TextId);
          let check = true;
          for (let i of value.WordsArray) {
            let span = document.getElementById(i.id);
            if (span) {
              check = false;
              break;
            }
          }
          if (check) {
            $el.innerHTML = "";
            for (let i of value.WordsArray) {
              triggerWordByWordFade($el, i);
            }
          }
        }
      }
    } else if (value.InClass == "animated WordByWordAppear ") {
      if (!value.player) {
        for (const i of WordByWordFadeIntervalsArr) {
          clearInterval(i);
        }
        for (const i of WordByWordFadeTimeoutsArr) {
          clearTimeout(i);
        }
      } else if (TickerPosition > value.startPositionOnTimeline) {
        //&& TickerPosition - value.startPositionOnTimeline > 1
        if (value.text == "") {
          resetWordsByAppear(false);
        }
        for (let i of value.WordsArray) {
          resumeWordByWordAppear(i);
        }
      } else if (TickerPosition <= value.startPositionOnTimeline) {
        // && value.text == ""
        // if (value.draggedBeforeStartPos) {
        //   resetWordsByFade();
        //   for (let i of value.WordsArray) {
        //     resumeWordByWordFade(i);
        //   }
        // }
        // else {
        let $el = document.getElementById(value.TextId);
        let check = true;
        for (let i of value.WordsArray) {
          let span = document.getElementById(i.id);
          if (span) {
            check = false;
            break;
          }
        }
        if (check) {
          $el.innerHTML = "";
          for (let i of value.WordsArray) {
            triggerWordByWordAppear($el, i);
          }
        }
        // }
      }
    } else if (value.InClass == "animated TextBounce ") {
      if (!value.player) {
        for (const i of WordByWordFadeIntervalsArr) {
          clearInterval(i);
        }
        // let $el = document.getElementById(value.TextId);
        // $el.innerHTML = '';
        for (let i of value.CharactersArray) {
          let span = document.getElementById(i.id);
          if (span && !span.getAttribute("data-doneBounce")) {
            span.style.opacity = 1;
            span.style.top = "0px";
          }
        }
      } else if (
        TickerPosition > value.startPositionOnTimeline &&
        TickerPosition - value.startPositionOnTimeline > 1
      ) {
        for (let i of value.CharactersArray) {
          let span = document.getElementById(i.id);
          if (span && !span.getAttribute("data-doneBounce")) {
            span.style.opacity = 0;
            span.style.top = value.fontSize + "px";
          }
        }
        animateLetterBounce();
      } else if (TickerPosition <= value.startPositionOnTimeline) {
        let $el = document.getElementById(value.TextId);
        $el.innerHTML = "";
        for (let i of value.CharactersArray) {
          triggerLetterBouncing($el, i, true);
        }
        animateLetterBounce();
      }
    } else if (value.InClass == "animated TypeWriter ") {
      if (!value.player) {
        for (const i of WordByWordFadeIntervalsArr) {
          clearInterval(i);
        }
        for (let i of value.CharactersArray) {
          let span = document.getElementById(i.id);
          if (span && !span.getAttribute("data-doneBounce")) {
            span.style.opacity = 1;
          }
        }
      } else if (
        TickerPosition > value.startPositionOnTimeline &&
        TickerPosition - value.startPositionOnTimeline > 1
      ) {
        for (let i of value.CharactersArray) {
          let span = document.getElementById(i.id);
          if (span && !span.getAttribute("data-doneBounce")) {
            span.style.opacity = 0;
          }
        }
        animateTypeWriter();
      } else if (TickerPosition <= value.startPositionOnTimeline) {
        let $el = document.getElementById(value.TextId);
        $el.innerHTML = "";
        for (let i of value.CharactersArray) {
          triggerTypeWriter($el, i, true);
        }
        animateTypeWriter();
      }
    } else if (value.InClass == "animated Rolling ") {
      let $el = document.getElementById(value.TextId);
      $el.innerHTML = "";
      for (let i of value.CharactersArray) {
        triggerLetterRolling($el, i, true);
      }
    }
  }, [value.player]);

  function resetWordsByFade(append = false) {
    if (
      value.startPositionOnTimeline + value.startTransitionWidth >=
      TickerPosition
    ) {
      if (TickerPosition - value.startPositionOnTimeline > 0 || append) {
        var StrCounter = value.WordsArray.length + 1;
        let tickerPositionInEffect =
          TickerPosition - value.startPositionOnTimeline;
        let divider = value.startTransitionWidth / StrCounter;
        let appendIndex = parseInt(tickerPositionInEffect / divider);
        let _opacity = (tickerPositionInEffect / divider) % 1;
        let $el = document.getElementById(value.TextId);
        $el.innerHTML = "";
        for (const j of value.WordsArray) {
          let span = document.createElement("span");
          span.style.opacity = 0;
          span.id = j.id;
          if (j.word == "") {
            span.style.opacity = 1;
            span.setAttribute("data-empty", "1");
          }
          span.innerHTML = j.word + j.next;
          $el.appendChild(span);
        }

        for (let j = 0; j < appendIndex - 1; j++) {
          let span = document.getElementById(value.WordsArray[j].id);
          if (j == appendIndex - 2) {
            span.style.opacity = _opacity;
          } else {
            span.style.opacity = 1;
          }
        }
      }
    }
  }

  useEffect(() => {
    let $el = document.getElementById(value.TextId);
    if ($el) {
      if (value.InClass == "animated TypeWriterr ") {
        if (!TypeWriterPlaying) {
          // _paused = false
          setIsPaused(false);
          TypeWriterPlaying = true;

          var i = 0;
          var txt = $el.innerHTML;
          var speed = 50;

          $el.innerHTML = "";
          function typeWriter() {
            if (!CanvasDisplay) {
              if (i < txt.length) {
                let textToAppend = txt.charAt(i);
                if (
                  txt.charAt(i) == "<" &&
                  txt.charAt(i + 1).toLocaleLowerCase() == "b" &&
                  txt.charAt(i + 2).toLocaleLowerCase() == "r" &&
                  txt.charAt(i + 3).toLocaleLowerCase() == ">"
                ) {
                  textToAppend = "<br>";
                  $el.innerHTML += textToAppend;
                  i = i + 4;
                } else if (
                  txt.charAt(i) == "&" &&
                  txt.charAt(i + 1).toLocaleLowerCase() == "n" &&
                  txt.charAt(i + 2).toLocaleLowerCase() == "b" &&
                  txt.charAt(i + 3).toLocaleLowerCase() == "s" &&
                  txt.charAt(i + 4).toLocaleLowerCase() == "p" &&
                  txt.charAt(i + 5).toLocaleLowerCase() == ";"
                ) {
                  textToAppend = "&nbsp;";
                  $el.innerHTML += textToAppend;
                  i = i + 6;
                } else {
                  $el.innerHTML += txt.charAt(i);
                  i++;
                }
                settimeOut(setTimeout(typeWriter, speed));
                // timeOut = setTimeout(typeWriter, speed);
              }
            }
          }
          typeWriter();
        }
      } else if (value.InClass == "animated WordByWordFade ") {
        // let check = true;
        // for (let i of value.WordsArray) {
        //   let span = document.getElementById(i.id);
        //   if (span) {
        //     check = false;
        //     break;
        //   }
        // }
        // if (check) {
        //   $el.innerHTML = '';
        //   for (let i of value.WordsArray) {
        //     triggerWordByWordFade($el, i);
        //   }
        // }
      }
    }
  }, [value.InClass]);

  useEffect(() => {
    if (CanvasDisplay && timeOut) {
      clearTimeout(timeOut);
      TypeWriterPlaying = false;
      // _paused = true;
      setIsPaused(true);
    }
    if (!CanvasDisplay && IsPaused) {
      // _paused = false
      setIsPaused(false);
      let $el = document.getElementById(value.TextId);
      if ($el) {
        if (value.InEffect == "animated TypeWriter ") {
          if (!TypeWriterPlaying) {
            TypeWriterPlaying = true;
            var i = $el.innerHTML.length;
            var txt = value.originalText;
            var speed = 50;
            // $el.innerHTML = '';
            function typeWriter() {
              if (!CanvasDisplay) {
                if (i < txt.length) {
                  let textToAppend = txt.charAt(i);
                  if (
                    txt.charAt(i) == "<" &&
                    txt.charAt(i + 1).toLocaleLowerCase() == "b" &&
                    txt.charAt(i + 2).toLocaleLowerCase() == "r" &&
                    txt.charAt(i + 3).toLocaleLowerCase() == ">"
                  ) {
                    textToAppend = "<br>";
                    $el.innerHTML += textToAppend;
                    i = i + 4;
                  } else if (
                    txt.charAt(i) == "&" &&
                    txt.charAt(i + 1).toLocaleLowerCase() == "n" &&
                    txt.charAt(i + 2).toLocaleLowerCase() == "b" &&
                    txt.charAt(i + 3).toLocaleLowerCase() == "s" &&
                    txt.charAt(i + 4).toLocaleLowerCase() == "p" &&
                    txt.charAt(i + 5).toLocaleLowerCase() == ";"
                  ) {
                    textToAppend = "&nbsp;";
                    $el.innerHTML += textToAppend;
                    i = i + 6;
                  } else {
                    $el.innerHTML += txt.charAt(i);
                    i++;
                  }

                  settimeOut(setTimeout(typeWriter, speed));
                  // timeOut = setTimeout(typeWriter, speed);
                }
              }
            }
            typeWriter();
          }
        }
      }
    }
  }, [CanvasDisplay]);

  const createTransformClass = () => {
    if (value.flip) {
      return value.flip + `rotate(${value.rotateAngle}deg)`;
    } else {
      return `rotate(${value.rotateAngle}deg)`;
    }
  };

  return (
    <>
      {value.opc === 1 && (
        <>
          <div
            key={index}
            tabIndex="0"
            className={
              "textUppperDiv changer " + value.InClass + value.OutClass
            }
            id={"Preview-" + value.AnimationId}
            style={{
              display: !CanvasDisplay
                ? value.player
                  ? "inline-block"
                  : "none"
                : TickerStart
                ? value.startPositionOnTimeline <= TickerPosition &&
                  value.startPositionOnTimeline + value.widthOnTimeline >=
                    TickerPosition
                  ? "inline-block"
                  : "none"
                : value.startPositionOnTimeline + value.startTransitionWidth <=
                    TickerPosition &&
                  value.startPositionOnTimeline +
                    value.widthOnTimeline -
                    value.startTransitionWidth >=
                    TickerPosition
                ? "inline-block"
                : "none",
              width: value.width + "px",
              height: value.height + "px",
              VendorAnimationDuration: ".5s",
              zIndex: zInd,
              transform: createTransformClass(),
              //transform: CanvasDisplay ? `rotate(${value.rotateAngle}deg)` : '',
              left: value.x,
              top: value.y,
            }}
          >
            <div
              key={index}
              tabIndex="0"
              style={{ textAlign: value.Align }}
              className={"textDivSize"}
            >
              <span
                key={index}
                id={value.TextId}
                style={{
                  textDecoration: value.textDec,
                  fontStyle: value.Fontstyle,
                  fontSize: value.fontSize + "px",
                  // fontSize: Math.round((value.fontSize * EditorZoom) / 100) + "px",
                  fontWeight: value.fontWeight,
                  opacity: value.opacity,
                  color: value.textColor,
                  overflowWrap: "break-word",
                  fontFamily: value.googleFontSetting.fontName,
                  transformOrigin: `top left`,
                  scale: value.scale,
                  maxWidth: value.width,
                  lineHeight: value.LineHeight,
                  letterSpacing: value.LetterSpacing + "em",
                }}
                tabIndex="0"
                className="textInput"
                spellCheck="false"
                dangerouslySetInnerHTML={{ __html: value.text }}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default PreviewText;
